import { render } from "./hotel.vue?vue&type=template&id=97330a5c&scoped=true"
import script from "./hotel.vue?vue&type=script&lang=js"
export * from "./hotel.vue?vue&type=script&lang=js"

import "./hotel.vue?vue&type=style&index=0&id=97330a5c&lang=scss&scoped=true"
import "./hotel.vue?vue&type=style&index=1&id=97330a5c&lang=scss"
script.render = render
script.__scopeId = "data-v-97330a5c"

export default script